import React from 'react'
import { type LayoutProps } from 'styled-system'
import { Card, CARD_PADDING_SIZE, CARD_ELEVATION } from 'components/Card'
import { Flex } from 'components/Layout'
import { useMedia } from 'useMedia'

interface SummaryWrapperProps extends LayoutProps {}

export const SummaryWrapper: React.VFC<
  React.PropsWithChildren<SummaryWrapperProps>
> = ({ children, ...props }) => {
  const { MOBILE: isMobile } = useMedia()

  return (
    <Flex height="max-content" {...props}>
      <Card
        paddingSize={
          isMobile ? CARD_PADDING_SIZE.NONE : CARD_PADDING_SIZE.DEFAULT
        }
        elevation={isMobile ? CARD_ELEVATION.NONE : CARD_ELEVATION.ELEVATION_4}
      >
        <Flex flexDirection="column" width="100%">
          {children}
        </Flex>
      </Card>
    </Flex>
  )
}
